module.exports = __webpack_public_path__ + "img/himo-family.27ac3898.png";